<template>
  <div v-if="isVisible" class="container" :class="[globalClasses]">
    <Accordion
      :title="accordionTitle"
      :always-open="isEditing"
      class="paragraph-accordion-field"
      :class="{
        'min-h-130': isEditing,
      }"
    >
      <BlokkliField name="field_paragraphs" :list="paragraphs" />
    </Accordion>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphGridFragment } from '#graphql-operations'

const { options } = defineBlokkli({
  bundle: 'accordion',
  globalOptions: ['region'],
  propsFieldMapping: {
    title: null,
    paragraphs: { type: 'field', name: 'field_paragraphs' },
  },
})

const isEditing = false

const props = defineProps<{
  title?: string
  paragraphs?: ParagraphGridFragment['paragraphs']
}>()

const { $texts } = useEasyTexts()

const accordionTitle = computed(
  () => props.title || $texts('accordionDefaultTitle'),
)

const { isVisible, globalClasses } = useMappedParagraphOptions(options)

defineOptions({
  name: 'ParagraphAccordion',
})
</script>

<style lang="postcss">
.paragraph-accordion-field {
  > *:last-child {
    @apply mb-20;
  }
}
</style>
